"use strict";
"use client";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionPanel = exports.AccordionHeader = exports.AccordionItem = exports.Accordion = exports.AccordionContext = void 0;
const react_1 = __importStar(require("react"));
exports.AccordionContext = (0, react_1.createContext)(undefined);
const Accordion = ({ children, className, defaultActiveKey = [], multiplePanelOpen = false, }) => {
    const accordionId = (0, react_1.useId)();
    const [openItems, setOpenItems] = (0, react_1.useState)(Array.isArray(defaultActiveKey) ? defaultActiveKey : [defaultActiveKey]);
    const toggleItem = (id) => {
        if (multiplePanelOpen) {
            setOpenItems((prev) => prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]);
        }
        else {
            setOpenItems((prev) => (prev.includes(id) ? [] : [id]));
        }
    };
    return (react_1.default.createElement(exports.AccordionContext.Provider, { value: { openItems, toggleItem, multiplePanelOpen } },
        react_1.default.createElement("div", { role: "region", "aria-labelledby": accordionId, className: className },
            react_1.default.createElement("h2", { id: accordionId, className: "sr-only" }, "Accordion Section"),
            children)));
};
exports.Accordion = Accordion;
const AccordionItem = ({ id, children, className }) => {
    const context = (0, react_1.useContext)(exports.AccordionContext);
    if (!context) {
        throw new Error("AccordionItem must be used within an Accordion");
    }
    const { openItems } = context;
    const isOpen = openItems.includes(id);
    return (react_1.default.createElement("div", { role: "presentation", "data-open": isOpen, className: `border-b border-grey350 last:border-b-0 ${className}` }, children));
};
exports.AccordionItem = AccordionItem;
const AccordionHeader = ({ id, children, iconOpen, iconClosed, iconPosition = "end", className, ariaLabel, }) => {
    const context = (0, react_1.useContext)(exports.AccordionContext);
    if (!context) {
        throw new Error("AccordionHeader must be used within an Accordion");
    }
    const { openItems, toggleItem } = context;
    const isOpen = openItems.includes(id);
    const handleClick = () => toggleItem(id);
    // Default icons
    const defaultIconOpen = (react_1.default.createElement("span", { className: "demo-icon icon-up-arrow text-[10px]" }));
    const defaultIconClosed = (react_1.default.createElement("span", { className: "demo-icon icon-down-arrow text-[10px]" }));
    return (react_1.default.createElement("button", { tabIndex: 0, id: `${id}-header`, "aria-controls": `${id}-panel`, "aria-expanded": isOpen ? "true" : "false", "aria-label": ariaLabel, onClick: handleClick, onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                toggleItem(id);
            }
        }, className: `flex items-center w-full text-left py-3 px-4 ${iconPosition === "start" ? "justify-start" : "justify-between"} ${className}` },
        iconPosition === "start" && (react_1.default.createElement("span", { className: "mr-2 flex items-center" }, isOpen ? iconOpen || defaultIconOpen : iconClosed || defaultIconClosed)),
        react_1.default.createElement("span", null, children),
        iconPosition === "end" && (react_1.default.createElement("span", { className: "ml-2 flex items-center" }, isOpen ? iconOpen || defaultIconOpen : iconClosed || defaultIconClosed))));
};
exports.AccordionHeader = AccordionHeader;
const AccordionPanel = ({ id, children, className, customRef }) => {
    const context = (0, react_1.useContext)(exports.AccordionContext);
    if (!context) {
        throw new Error("AccordionPanel must be used within an Accordion");
    }
    const { openItems } = context;
    const isOpen = openItems.includes(id);
    const panelRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const panel = panelRef.current;
        if (!panel)
            return;
        let timer;
        if (isOpen) {
            // Expand animation
            panel.style.maxHeight = `${panel.scrollHeight}px`;
            // Allow dynamic height after expansion
            timer = setTimeout(() => {
                panel.style.overflow = "visible";
                panel.style.maxHeight = "none";
            }, 200);
        }
        else {
            // Ensure maxHeight is set before collapsing
            panel.style.maxHeight = `${panel.scrollHeight}px`;
            requestAnimationFrame(() => {
                panel.style.overflow = "hidden";
                panel.style.maxHeight = "0"; // Collapse smoothly
            });
        }
        // Update focusable elements when the panel toggles
        const focusableElements = panel.querySelectorAll("a, button, input, select, textarea, [tabindex]");
        focusableElements.forEach((el) => {
            el.tabIndex = isOpen ? 0 : -1;
        });
        return () => clearTimeout(timer);
    }, [isOpen]);
    return (react_1.default.createElement("div", { ref: panelRef, id: `${id}-panel`, role: "region", "aria-labelledby": `${id}-header`, "aria-hidden": !isOpen, className: `overflow-hidden max-h-0 transition-all duration-300 ease-in-out ${className}` },
        react_1.default.createElement("div", { ref: customRef, className: "p-4", ...(!isOpen ? { tabIndex: -1 } : {}) }, children)));
};
exports.AccordionPanel = AccordionPanel;
